import { Alert } from "@material-ui/lab";
import React from "react";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../../styles/styledTable";
import ClientItem from "./ClientItem";

const ClientList = ({ t, clients }) => {

  if (!clients) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (clients.length === 0) {
    return <Alert severity="warning">{t("clientsList.table.emptyData")}</Alert>;
  }

  return (
    <>
      <StyledScrollTable>
        <StyledTable
          width="992"
          size="16"
          className="client-table"
        >
          <StyledTableHead
            scroll="auto"
            col="5"
            className="client-table__head"
          >
            <div>
              {t("clientsList.table.nickname")}
            </div>
            <div>
              {t("clientsList.table.firstname")}
            </div>
            <div>
              {t("clientsList.table.lastname")}
            </div>
            <div>
              E-mail
            </div>
            <div>
              {t("clientsList.table.createDate")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {clients && clients?.map((item, key) => (
              <ClientItem
                key={key}
                value={item.user}
              />
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};
export default ClientList;